import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литература. 8 класс",
        subject: "Идейно-художественное содержание поэмы А.Т. Твардовского «Василий Тёркин»",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Идейно-художественное содержание поэмы А.Т. Твардовского «Василий Тёркин»",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Критарова Жанна Николаевна",
                grade: "к.пед.н.",
                subGrade: "старший научный сотрудник лаборатории филологического общего образования ФГБНУ «ИСРО»",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Изучение произведений о Великой Отечественной войне в современной России играет чрезвычайно важную роль в школьном литературном образовании. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В программе по литературе для основной образовательной школы этой теме посвящены отдельные произведения и разделы. Так, в 5 классе в разделе «Произведения отечественной литературы» на тему «Человек на войне» (не менее двух) предлагаются для изучения повести Льва Кассиля «Дорогие мои мальчишки» и Валентина Катаева «Сын полка», рассказ Юрия Яковлева «Девочки с Васильевского острова», стихотворение Константина Симонова «Сын артиллериста» и другие.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В 6 классе в разделе «Проза отечественных писателей конца XX – начала XXI века, в том числе о Великой Отечественной войне» (два произведения по выбору) учитель может остановить свой выбор, например, на рассказах Бориса Васильева «Экспонат №...», Бориса Екимова «Ночь исцеления», на главе «Очень страшный 1942 Новый год» повести-сказки Андрея Жвалевского и Евгении Пастернак «Правдивая история Деда Мороза»  и другие.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В федеральной рабочей программе произведения о Великой Отечественной войне в 8 классе содержатся в разделе «Литература второй половины XX века», в связи с чем необходимо изучать поэму Твардовского и произведения других авторов в контексте военной тематики. На изучение поэмы «Василий Тёркин» отводится 3 часа, указан примерный перечень глав («Переправа», «Гармонь», «Два солдата», «Поединок» и др.).</p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Поэма «Василий Тёркин» – центральное произведение в творчестве Александра Трифоновича Твардовского. Как отмечал Константин Симонов, «лучшее из всего написанного о войне на войне», одна из вершин русской эпической поэзии вообще.  </p>
                        <p>Задумывая рассказ о простом бойце, поэт писал: «При удаче это будет ценнейший подарок армии, это будет её любимец, нарицательное имя. Для молодёжи это должно быть книжкой, которая делает любовь к армии более земной, конкретной».</p>
                        <p>Об истинной народности поэмы Твардовского Иван Бунин писал в 1947 году из Парижа: «…Это поистине редкая книга: какая свобода, какая чудесная удаль, какая меткость, точность во всём и какой необыкновенный народный солдатский язык – ни сучка, ни задоринки, ни единого фальшивого, готового, то есть литературно-пошлого слова!».</p>
                        <p>С поэмой Александра Трифоновича Твардовского «Василий Теркин» предстоит поработать на уроке литературы в 8 классе на протяжении трёх часов. Распланировать уроки и распределить материал на каждый из них поможет конструктор рабочих программ по литературе.
Первый урок отводится на знакомство с историей создания поэмы, её проблематикой и идейно-художественным содержанием, второй урок посвящён главному герою, на третьем уроке рассматривается родо-жанровое и художественное своеобразие поэмы.
Остановимся на отдельных аспектах изучения поэмы в школе.
</p>`
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Александр Твардовский. Как был написан «Василий Тёркин» (ответ читателям). URL: http://lib.ru/POEZIQ/TWARDOWSKIJ/as_ter.txt# (дата обращения: 16.08.2023)",
                "Бабаева Е. В., Ганьшина Г. В. Бой идёт не ради славы, ради жизни на земле // Российские регионы: взгляд в будущее. 2015. №2 (3). URL: https://cyberleninka.ru/article/n/boy-idet-ne-radi-slavy-radi-zhizni-na-zemle (дата обращения: 16.08.2023).  ",
                "Воспоминания об А. Твардовском.  Москва: Советский писатель, 1978. 488 стр. URL: https://imwerden.de/pdf/vospominaniya_o_tvardovskom_1978__ocr.pdf (дата обращения: 18.09.2023)",
                "Гапеева В.И., Кузнецова Э.В.  «Беседы о советских художниках». Ю. М. Непринцев. «Отдых после боя». Москва-Ленинград: Просвещение, 1964 г. URL: http://www.detskiysad.ru/artvek/beseda30.html (дата обращения: 15.09.2023).",
                "Головня М.В. Антитеза как средство выражения экспрессивности в поэзии А. Т. Твардовского // Современное педагогическое образование, 2019. №8. URL: https://cyberleninka.ru/article/n/antiteza-kak-sredstvo-vyrazheniya-ekspressivnosti-v-poezii-a-t-tvardovskogo  (дата обращения: 18.08.2023)",
                "Критарова Ж.Н. Анализ произведений русской литературы. 8 класс.  Москва: Экзамен, 2020",
                "Снигирёва Т. А. «Навсегда, Василий Тёркин, подружились мы с тобой» (поэма «Василий Тёркин» в контексте творчества А. Твардовского военных лет) // Филологический класс. 2010. №23. URL: https://cyberleninka.ru/article/n/navsegda-vasiliy-terkin-podruzhilis-my-s-toboy-poema-vasiliy-terkin-v-kontekste-tvorchestva-a-tvardovskogo-voennyh-let (дата обращения: 16.07.2023)",
                "Твардовский А. Т. Василий Тёркин / Изд. подг. А. Л. Гришунин. Москва: Наука, 1978. C. 285. (Серия «Литературные памятники»). URL: https://imwerden.de/pdf/tvardovsky_vasily_terkin_1976_text.pdf  (дата обращения: 16.07.2023)",
                "Туманова С. Р. «Ради жизни на земле» (об одном из аспектов поэмы А. Т. Твардовского «Василий Тёркин») // Полилингвиальность и транскультурные практики. 2013. №1. URL: https://cyberleninka.ru/article/n/radi-zhizni-na-zemle-ob-odnom-iz-aspektov-poemy-a-t-tvardovskogo-vasiliy-tyorkin (дата обращения: 16.08.2023)",
                "Энциклопедический словарь-справочник. Выразительные средства русского языка и речевые ошибки и недочёты [Электронный ресурс] / под ред. А.П. Сковородникова. 3-е изд., стереотип. Москва: Флинта, 2011. 480 с. URL: http://uchitel-slovesnosti.ru/slovari/23.pdf (дата обращения: 18.07.2023)",
                "Шутан М.И. «Василий Тёркин» Александра Твардовского. Материалы к уроку. Журнал «Литература» №9, 2008 г. URL: https://lit.1sept.ru/article.php?ID=200800910  (дата обращения: 18.09.2023)",
            ],
            sites: [
                ""
            ],
            filesToDownload: [
            ]
        }
    ],
};
